import {Link} from "react-router-dom";
import {Alert} from "antd";
import {FontAwesomeIcon, PageHeader, Button} from "~/components";
import AiGenerator from "../components/AiGenerator";

/**
 * Màn AI SEO ĐỘC LẬP (`/ai`): sinh nội dung ad-hoc, không gắn dự án (project_id=0).
 * Bản gắn dự án (có trợ lý phân tích dữ liệu) là `features/AiTool/pages/AiProjectHome.js`.
 */
function AiTool() {
	return (
		<div className="container">
			<PageHeader
				icon="fa-light fa-wand-magic-sparkles"
				title="AI SEO"
				subtitle="Sinh nội dung SEO nhanh bằng AI — không cần gắn với dự án nào."
				actions={
					<Button to="/ai/history" white
						leftIcon={<FontAwesomeIcon icon="fa-light fa-clock-rotate-left" />}>
						Lịch sử
					</Button>
				}
			/>

			{/* Phân biệt với "Trợ lý AI" trong dự án — user hay nhầm 2 mục AI. */}
			<Alert
				type="info"
				showIcon
				closable
				style={{marginBottom: 16}}
				message="Trang này dùng để sinh nội dung nhanh (meta, FAQ, dàn ý, bài viết...) không gắn dự án."
				description={
					<span>
						Muốn AI <strong>phân tích website theo dữ liệu thật</strong> (crawl, điểm SEO, Search Console, PageSpeed)?
						Hãy mở <Link to="/projects">dự án của bạn</Link> → công cụ <strong>AI SEO</strong> → tab <strong>Trợ lý AI</strong>.
					</span>
				}
			/>

			<AiGenerator projectId={0} />
		</div>
	);
}

export default AiTool;
